import React from 'react';
import PropTypes from 'prop-types';
import styles from './Ribbon.scss';
import {auctionStatus} from '../../lib/config';

const recentSaleAuctionStatus = [auctionStatus.SOLD, auctionStatus.UNDER_OFFER, auctionStatus.FINAL_BIDDING_STAGE];
const closedAuctions = [auctionStatus.CLOSED, auctionStatus.CANCELLED];
const auctionSaleTypes = {
  'AUCTION': 'Online Auction',
  'PRIVATE TREATY': 'Online Offers'
};


const PackageRibbon = (props) => {
  const {customStyle, className = '',
    property: {
      type,
      lastSale,
      recentlySold,
    },
    listing: {
      landCategory,
      isNewConstruction = false,
      isHomeLandPackage = false,
      auction,
    }} = props;

  const isRecentSaleWithAuction = (recentlySold, lastSale) => {
    return recentlySold && lastSale && lastSale.lastListingId && lastSale.auction?.auctionPartner?.toUpperCase() === 'OPENN'
        && recentSaleAuctionStatus.includes(lastSale.auction?.auctionStatus?.toUpperCase());
  };

  const isListingWithAuction = (auction) => {
    return auction?.auctionPartner?.toUpperCase() === 'OPENN' && !closedAuctions.includes(auction?.auctionStatus?.toUpperCase());
  };

  const _getPackageName = () => {
    let text = '';

    if (isListingWithAuction(auction)) {
      return auctionSaleTypes[auction.saleType?.toUpperCase()];

    } else if (isRecentSaleWithAuction(recentlySold, lastSale)) {
      return auctionSaleTypes[lastSale.auction.saleType?.toUpperCase()];

    }

    if (!isNewConstruction && !isHomeLandPackage && type === 'Land' && landCategory === 'Residential') {
      text = 'Land';
    }

    if((isNewConstruction && isHomeLandPackage) || (!isNewConstruction && isHomeLandPackage))
      text = 'House & Land';
    else if(!isHomeLandPackage && isNewConstruction)
      text = 'New Build';

    return text;
  };
  const packageText = _getPackageName();

  return (
    <>
      { packageText &&
        <div style={ customStyle } className={`pt-1 pb-1 text-uppercase ${styles.wrapper} ${className}`}>
          {packageText}
        </div>
      }
    </>
  );
};


PackageRibbon.propTypes = {
  property: PropTypes.object,
  listing: PropTypes.object,
  customStyle: PropTypes.object,
  className: PropTypes.string,
};

export default PackageRibbon;